<template>
    <div id="provider" class="ui segment">
        <h1 class="ui header">
            <!-- 公司資訊 -->
            {{ $t('ui.pages.nodes.company_information') }}
        </h1>
        <div class="ui divider"></div>
        <div class="ui form" v-if="is_initialized">
            <div class="ui grid" style="margin-top:0;margin-bottom:0">
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.tax') }}</label>
                    <input type="text" v-model="provider_node.tax">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.company_name') }}</label>
                    <input type="text" v-model="provider_node.company_name">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.company_short_name') }}</label>
                    <input type="text" v-model="provider_node.company_short_name">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.company_en_name') }}</label>
                    <input type="text" v-model="provider_node.company_en_name">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.email') }}</label>
                    <input type="text" v-model="provider_node.email">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.phone') }}</label>
                    <input type="text" v-model="provider_node.phone">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.fax') }}</label>
                    <input type="text" v-model="provider_node.fax">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.customer_service_hotline') }}</label>
                    <input type="text" v-model="provider_node.customer_service_hotline">
                </div>
                <div class="wide field" :class="style.width > 767 ? 'eight' : 'sixteen'">
                    <label>{{ $t('models.attributes.nodes.website_url') }}</label>
                    <input type="text" v-model="provider_node.website_url">
                </div>
            </div>

            <div class="ui divider"></div>

            <div class="ui blue button" @click="update_provider_node">
                {{ $t('ui.general.update') }}
            </div>
        </div>
        <div v-else class="ui active inverted dimmer">
            <div class="ui text loader">
                <!-- 處理中... -->
                {{ $t('ui.general.initializing') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProviderNodeMain",
    data() {
        return {
            is_initialized: false,
            provider_node: {},
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init',(value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await this.fetch_provider_node()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_provider_node() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_me).parse(
                {},
                ""
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.provider_node = response.data.node
                })
                .catch(error => {
                    // this.$noty.error("抓取公司資料失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.nodes'),
                            reason: ': ' + error
                        })
                    )
                })
        },
        update_provider_node() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_me_update).parse(
                {},
                ""
            )
            var params = this.provider_node
            return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        // this.$noty.success("更新公司資料成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.nodes')
                            })
                        )
                        this.provider_node = response.data.node
                        this.$store.dispatch('provider/fetch_node')
                    } else {
                        // this.$noty.error("更新公司資料失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.$t('models.nodes')
                            })
                        )
                    }
                })
                .catch(error => {
                    // this.$noty.error("更新公司資料失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.nodes')
                        })
                    )
                })
        }
    },
    components: {
    }
}
</script>
